/* The tabs and the open panel sit straight in the page's own column, so the
   page's gap spaces them. */
.root {
  display: contents;
}

.list {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-12);
}

.tab {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-8);
  margin: 0;
  padding: var(--zumpo-space-8);
  border: 0;
  border-radius: var(--zumpo-radius-999);
  background: var(--zumpo-paper);
  color: var(--zumpo-ink);
  font: var(--zumpo-text-small);
  letter-spacing: var(--zumpo-text-small-tracking);
  white-space: nowrap;
  cursor: pointer;
}

/* Drawn 34 px tall, a tab takes a tap from 46 px, more than the 44 a thumb
   needs: the area reaches 6 px around it, halfway into the gaps beside it. */
.tab::before {
  position: absolute;
  inset: calc(-1 * var(--zumpo-space-6));
  content: '';
}

.tab[data-active] {
  background: var(--zumpo-ink);
  color: var(--zumpo-white);
}

/* Zumpo/Mobile tabs' Chat unread: how many lines arrived out of sight;
   Board turn: it is your go, while another tab is open. */
.unread,
.turn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 var(--zumpo-space-6);
  border-radius: var(--zumpo-radius-999);
  background: var(--zumpo-coral);
  color: var(--zumpo-ink);
  font: var(--zumpo-text-small);
  letter-spacing: var(--zumpo-text-small-tracking);
}

.turn {
  background: var(--zumpo-lime);
}

.tab:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

/* The open panel passes the page's height on, so a game in play on a phone
   fits one screen (play-board.tsx). */
.panel {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
}

/* The turn mark, said to a screen reader as it appears. */
.announce {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
